import React from "react";
import { inject, observer } from "mobx-react";
import ImageStep from "../ImageStep";
import GridStep from "../GridStep";
import SummaryStep from "../SummaryStep";
import PdfStep from "../PdfStep";
import PaymentStep from "../PaymentStep";
import BrokerStep from "../BrokerStep";
import FactoryFormStep from "../FactoryFormStep";

@inject("AppStore")
@observer
class StepContent extends React.Component {
  store = this.props.AppStore;

  // Render regular steps
  renderSteps = () => {
    const { page, data } = this.store;

    return (
      !page.hideSteps &&
      data.steps.map((step, i) => (
        <div
          key={i}
          className={`step-content-inner visible-mobile ${
            i === page.stepIndex && "flex animate__animated animate__fadeIn"
          }`}
          data-title={step.title}
        >
          <div className="title">
            <span>{this.store.translate(step.title_t)}</span>
          </div>
          {step.type === "Image" && (
            <ImageStep store={this.store} step={step} data={data} />
          )}
          {step.type === "Grid" && <GridStep store={this.store} step={step} />}
        </div>
      ))
    );
  };

  // Render summary step
  renderSummaryStep = () => {
    const { page } = this.store;

    return (
      <div
        id="step-summary"
        className={`step-content-inner visible-mobile ${
          page.summaryStep === page.stepIndex &&
          "flex animate__animated animate__fadeIn"
        }`}
        data-title="SUMMARY"
      >
        <div className="title" id="summary">
          {this.store.page.lang === "en" ? "SUMMARY" : "ÖZET"}
        </div>
        <SummaryStep store={this.store} />
      </div>
    );
  };

  // Render PDF step
  renderPdfStep = () => {
    const { page } = this.store;

    return (
      <div
        className={`step-content-inner ${
          page.pdfStep === page.stepIndex &&
          "flex animate__animated animate__fadeIn"
        }`}
        data-title="Pdf"
      >
        <div className="title" id="pdf">
          PDF
        </div>
        <PdfStep store={this.store} />
      </div>
    );
  };

  // Render Payment step
  renderPaymentStep = () => {
    const { page } = this.store;

    return (
      <div
        className={`step-content-inner ${
          page.paymentStep === page.stepIndex &&
          "flex animate__animated animate__fadeIn"
        }`}
        data-title="Payment"
      >
        <div className="title" id="payment">
          Payment
        </div>
        <PaymentStep store={this.store} />
      </div>
    );
  };

  // Render Broker step
  renderBrokerStep = () => {
    const { page } = this.store;

    return (
      <div
        className={`step-content-inner ${
          page.brokerStep === page.stepIndex &&
          "flex animate__animated animate__fadeIn"
        }`}
        data-title="Broker"
      >
        <div className="title" id="broker">
          BROKER
        </div>
        <BrokerStep store={this.store} />
      </div>
    );
  };

  // Render Factory step
  renderFactoryStep = () => {
    const { page } = this.store;

    return (
      <div
        className={`step-content-inner ${
          page.factoryStep === page.stepIndex &&
          "flex animate__animated animate__fadeIn"
        }`}
        data-title="Factory"
      >
        <div className="title" id="broker">
          FACTORY FORM
        </div>
        <FactoryFormStep store={this.store} />
      </div>
    );
  };

  render() {
    const { page } = this.store;

    return (
      <>
        {page.completeStep !== page.stepIndex && (
          <React.Fragment>
            {this.renderSteps()}
            {this.renderSummaryStep()}
            {this.renderPdfStep()}
            {this.renderPaymentStep()}
            {this.renderBrokerStep()}
            {this.renderFactoryStep()}
          </React.Fragment>
        )}
      </>
    );
  }
}

export default StepContent;
